import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SpinnerComponent } from "./spinner.component";
import { AngularSvgIconModule } from "angular-svg-icon";

@NgModule({
  declarations: [SpinnerComponent],
  imports: [CommonModule, AngularSvgIconModule],
  exports: [SpinnerComponent],
})
export class SpinnerModule {}
